import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/subYears/index.js';

var require$$17 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$17 as default };
